import React, {ReactNode} from 'react';
import './SidebarScrollableContent.scss';

export interface SidebarScrollableContentProps {
  children: ReactNode;
}

const SidebarScrollableContent: React.FunctionComponent<SidebarScrollableContentProps> = ({ children }) => {
  return <div className="sidebar-scrollable-content">
    {children}
  </div>
};

export default SidebarScrollableContent;
